module.exports = __webpack_public_path__ + "img/Group 147.09531032.jpg";